<template lang="pug">
.judgement-update-confirm-modal
  b-modal(v-model="_value" size="lg" no-close-on-backdrop no-close-on-esc @ok="ok" @cancel="cancel")
    .check-delete-modal-body
      .confirm-title 入所評価判定を変更しますか？
      .confirm-body(v-if="0 < targetFacilities.length")
        span 入所評価判定を同時に登録したい施設にチェックを入れてください。
        .mb-2
        .facilities
          .facility(v-for="(facility, index) in targetFacilities")
            b-form-checkbox(v-model="targetFacilities[index].checked" :value="true" :unchecked-value="false") {{ facility.name }}

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(type="button" @click="ok()") OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### チェックボックス付き削除確認モーダル
 */
@Component
export default class JudgementUpdateConfirmModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** 並列登録する他施設 */
  @Prop({ required: true })
  targetFacilities!: Array<TargetFacility>;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * OKボタン押下イベント
   */
  public ok(): void {
    this.$emit("ok");

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  public cancel(): void {
    for (let facility of this.targetFacilities) {
      facility.checked = false;
    }
    this.$emit("cancel");

    return;
  }
}

export interface TargetFacility {
  /** 施設ID */
  id: number;
  /** 施設名 */
  name: string;
  /** 選択したか否か */
  checked: boolean;
}
</script>
